import React from 'react';

const TextButton = ({text, onClick, className, size}) => {
    return (
        <button onClick={onClick} className={`text-button ${className || ''} ${size || ''}`}>{text}</button>
    );
}

export default TextButton;
